import axios from "axios";
import qs from "qs";

import { api } from "@/plugins/util";

/**
 * 申请权限
 */
export function application() {
    return axios.get(api + "/Applications/add", );
}

/**
 * 获取权限列表
 */
export function getApplications(name, type, page) {
    return axios.get(api + "/Applications/getList", {
        params: {
            name,
            type,
            page
        }
    });
}

/**
 * 审核通过
 */
export function Approved(id) {
    return axios.get(api + "/Applications/approved", {
        params: {
            id
        }
    });
}
